/**
 * The Conference preset's one choice (ISSUE-1266): the league's conferences
 * from sports-api, the same list Scores narrows college slates with. A league
 * with no conferences on file says so instead of offering an empty picker.
 */
import { useLeagueConferenceList } from "@sportsmet/sports-sdk/private";
import { InlineBanner, Select, Skeleton } from "@sportsmet/ui";
import type { ReactNode } from "react";

import {
  SQUARES_CONFERENCE_LABEL,
  SQUARES_CONFERENCE_LOADING,
  SQUARES_CONFERENCE_NONE,
  SQUARES_CONFERENCE_PLACEHOLDER,
} from "./squaresCopy";
import { useSquaresLeagueId } from "./useSquaresLeagueId";

export type typeSquaresConferencePickerProps = {
  leagueKey: string;
  conferenceKey: string | null;
  onChange: (conferenceKey: string) => void;
};

export const SquaresConferencePicker = (
  props: typeSquaresConferencePickerProps,
): ReactNode => {
  const leagueId = useSquaresLeagueId(props.leagueKey);
  const read = useLeagueConferenceList(
    { leagueId: leagueId ?? "" },
    { enabled: leagueId !== null },
  );
  const conferences = read.data?.data?.conferences ?? [];

  if (leagueId === null || read.isPending) {
    return (
      <div aria-label={SQUARES_CONFERENCE_LOADING}>
        <Skeleton className="h-10" />
      </div>
    );
  }
  if (conferences.length === 0) {
    return <InlineBanner variant="warning" message={SQUARES_CONFERENCE_NONE} />;
  }
  return (
    <Select
      label={SQUARES_CONFERENCE_LABEL}
      value={props.conferenceKey ?? undefined}
      placeholder={SQUARES_CONFERENCE_PLACEHOLDER}
      items={conferences.map((conference) => ({
        value: conference.conferenceKey,
        label: conference.label,
      }))}
      onValueChange={props.onChange}
    />
  );
};
